"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireDefault(require("react"));

var _classnames = _interopRequireDefault(require("classnames"));

var IconCardHorizontal = function IconCardHorizontal(_ref) {
  var style = _ref.style,
      className = _ref.className;
  return _react.default.createElement("svg", {
    xmlns: "http://www.w3.org/2000/svg",
    width: "16",
    height: "16",
    viewBox: "0 0 16 16",
    className: (0, _classnames.default)('Icon', 'IconCardHorizontal', className),
    style: style
  }, _react.default.createElement("path", {
    fillRule: "evenodd",
    d: "M14.25,13.5 C14.6642136,13.5 15,13.8357864 15,14.25 C15,14.6642136 14.6642136,15 14.25,15 L14.25,15 L1.75,15 C1.33578644,15 1,14.6642136 1,14.25 C1,13.8357864 1.33578644,13.5 1.75,13.5 L1.75,13.5 Z M14,4 C14.5522847,4 15,4.43679537 15,4.97560976 L15,11.0243902 C15,11.5632046 14.5522847,12 14,12 L2,12 C1.44771525,12 1,11.5632046 1,11.0243902 L1,4.97560976 C1,4.43679537 1.44771525,4 2,4 L14,4 Z M13.2,5.5 L2.80000001,5.5 C2.63431458,5.5 2.5,5.63431458 2.5,5.80000001 L2.5,10.2 C2.5,10.3656854 2.63431458,10.5 2.80000001,10.5 L13.2,10.5 C13.3656854,10.5 13.5,10.3656854 13.5,10.2 L13.5,5.80000001 C13.5,5.63431458 13.3656854,5.5 13.2,5.5 Z M1.75,1 L14.25,1 C14.6642136,1 15,1.33578644 15,1.75 C15,2.12969577 14.7178461,2.44349096 14.3517706,2.49315338 L14.25,2.5 L1.75,2.5 C1.33578644,2.5 1,2.16421356 1,1.75 C1,1.37030423 1.28215388,1.05650904 1.64822944,1.00684662 L1.75,1 L14.25,1 Z"
  }));
};

var _default = IconCardHorizontal;
exports.default = _default;